import React from "react";
import { CardsContainer } from "./FloatingCards.styles";
import CardComponent from "./Components/Card/Card";
import { useNavigate } from "react-router";

const FloatingCards = () => {
  const navigate = useNavigate();
  return (
    <CardsContainer>
      <div className="float-cards-container">
        <CardComponent onClick={() => navigate("/birthday-party")} />
        <CardComponent
          onClick={() => navigate("/anniversary-party")}
          icon="💍"
          title="Anniversary"
          description="Celebrate your special milestone with a romantic and intimate private theatre experience. Create lasting memories with a customised movie night just for the two of you."
        />
        <CardComponent
          onClick={() => navigate("/parties-and-events")}
          icon="🎉"
          title="Parties & Events"
          description="From reunions and farewells to casual get-togethers, our private theatres offer a unique and exclusive venue for any special occasion with a one-of-a-kind cinematic experience."
        />
      </div>
    </CardsContainer>
  );
};

export default FloatingCards;
